import { createStore } from '@stencil/store';
import {
  disableScrollBody,
  enableScrollBody
} from '../../../../../../apps/website-frontend/src/ts/helpers/body-scroll.helper';
import { SearchResultModel } from '../models/search-result.model';
import { QuickProductSearchLogService } from '../services/quick-product-search-log.service';

interface QuickSearchState {
  productRoute: string;
  region: string;
  query: string;
  pageSize: number;
  currentPage: number;
  result: SearchResultModel;
  isLoading: boolean;
}

const { state, onChange, set, get } = createStore<QuickSearchState>({
  productRoute: null,
  region: null,
  query: '',
  pageSize: (window.innerHeight < 800 && 2) || (window.innerWidth <= 480 ? 3 : 6),
  currentPage: 1,
  result: null,
  isLoading: false
});

export { state, get, set };

onChange('result', value => {
  if (value) {
    disableScrollBody();
    const scrollToElement = document.getElementsByTagName('quick-product-search')?.[0];
    if (scrollToElement) scrollToElement.scrollIntoView();
  } else {
    enableScrollBody();
  }
  QuickProductSearchLogService.handleNothingFound();
});

